import { SET_CLEAR_CREATE_CONTROL_POINT, SET_CREATE_CONTROL_POINT } from "../actions/createContolPointActions";
import { v4 as uuidv4 } from "uuid";

const initialState = {
  createControlPoint: null,
  featureKey: null,
  errors: [],
};

const createControlPointReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CREATE_CONTROL_POINT: {
      return Object.assign({}, state, {
        createControlPoint: action.data,
      });
    }

    case SET_CLEAR_CREATE_CONTROL_POINT: {
      return Object.assign({}, state, {
        createControlPoint: null,
        featureKey: uuidv4(),
      });
    }

    default:
      return state;
  }
};

export default createControlPointReducer;
